import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Rectangle with diagonal feature.
 *
 * Verifiable properties:
 * - Both diagonals have equal length
 * - Diagonals bisect each other (intersection is the center)
 */
export const RECTANGLE_FEATURES_PRESET: GeometryPadWidgetConfig = {
  id: 'rectangle-features',
  type: 'geometrypad',
  params: {
    elements: {
      r1: {
        type: 'Rectangle',
        params: { w: 6, h: 4 },
      },
      'diagonal.r1': { type: 'Diagonal', params: { of: 'r1' } },
    },
  },
  display: {},
};
